export const AVATAR_CUSTOMER = 'AVATAR_CUSTOMER';
export const AVATAR_SOURCE_TWILIO = 'twilio_chat';
export const AVATAR_ANONYMOUS_NAME = 'Anonymous';
